import { initAccordion } from './accordion';

/** One idempotent entry point for static, Alpine, or server-inserted panels. */
export function initPanelBehaviors() {
  const mounted=new Map();
  const selector='[data-accordion], [data-carousel], [data-timeline], [data-leadership], [data-chart], [data-listing], [data-mosaic], [data-hero-title-reveal], [data-hero-stats], [data-reveal-sequence], [data-title-reveal]';
  let carouselModule,timelineModule,leadershipModule,chartModule,listingModule,mosaicModule,heroTitleModule,heroStatsModule,revealModule,titleRevealModule;
  function mount(root) {
    if(mounted.has(root)) return;
    const state={dispose:null,cancelled:false};mounted.set(root,state);
    if(root.matches('[data-accordion]')) state.dispose=initAccordion(root);
    else if(root.matches('[data-mosaic]')) {
      mosaicModule??=import('./media-mosaic');
      mosaicModule.then(({initMediaMosaic})=>{if(!state.cancelled&&root.isConnected)state.dispose=initMediaMosaic(root);}).catch(()=>{mosaicModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-listing]')) {
      listingModule??=import('./listing');
      listingModule.then(({initListing})=>{if(!state.cancelled&&root.isConnected)state.dispose=initListing(root);}).catch(()=>{listingModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-chart]')) {
      chartModule??=import('./stat-chart');
      chartModule.then(({initStatChart})=>{if(!state.cancelled&&root.isConnected)state.dispose=initStatChart(root);}).catch(()=>{chartModule=undefined;mounted.delete(root);});
    }
    else if(root.matches('[data-timeline]')) {
      timelineModule??=import('./timeline');
      timelineModule.then(({initTimeline})=>{if(!state.cancelled&&root.isConnected)state.dispose=initTimeline(root);}).catch(()=>{timelineModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-leadership]')) {
      leadershipModule??=import('./leadership');
      leadershipModule.then(({initLeadership})=>{if(!state.cancelled&&root.isConnected)state.dispose=initLeadership(root);}).catch(()=>{leadershipModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-hero-title-reveal]')) {
      heroTitleModule??=import('./hero-title-reveal');
      heroTitleModule.then(({initHeroTitleReveal})=>{if(!state.cancelled&&root.isConnected)state.dispose=initHeroTitleReveal(root);}).catch(()=>{root.dataset.heroTitleRevealReady='true';heroTitleModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-hero-stats]')) {
      heroStatsModule??=import('./hero-stats');
      heroStatsModule.then(({initHeroStats})=>{if(!state.cancelled&&root.isConnected)state.dispose=initHeroStats(root);}).catch(()=>{heroStatsModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-title-reveal]')) {
      titleRevealModule??=import('./title-reveal');
      titleRevealModule.then(({initTitleReveal})=>{if(!state.cancelled&&root.isConnected)state.dispose=initTitleReveal(root);}).catch(()=>{root.dataset.titleRevealReady='true';titleRevealModule=undefined;mounted.delete(root);});
    } else if(root.matches('[data-reveal-sequence]')) {
      revealModule??=import('./reveal-sequence');
      revealModule.then(({initRevealSequence})=>{if(!state.cancelled&&root.isConnected)state.dispose=initRevealSequence(root);}).catch(()=>{root.classList.add('is-visible');revealModule=undefined;mounted.delete(root);});
    } else {
      carouselModule??=import('./carousel');
      carouselModule.then(({initCarousel})=>{if(!state.cancelled&&root.isConnected) state.dispose=initCarousel(root);}).catch(()=>{carouselModule=undefined;mounted.delete(root);});
    }
  }
  function scan(node) {if(node.nodeType!==1) return;if(node.matches(selector))mount(node);node.querySelectorAll(selector).forEach(mount);}
  scan(document.documentElement);
  const observer=new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(scan));
    for(const [root,state] of mounted) if(!root.isConnected) {state.cancelled=true;state.dispose?.();mounted.delete(root);}
  });
  observer.observe(document.body,{childList:true,subtree:true});
  return ()=>{observer.disconnect();for(const state of mounted.values()){state.cancelled=true;state.dispose?.();}mounted.clear();};
}
